export default class GlobalValues {
  static isLocal = false;
  static endPointUrl = this.isLocal
    ? "https://localhost:5001/api"
    : "https://tokenapi.likestoryeg.com/api";
  static signalREndPoint = this.isLocal
    ? "https://localhost:5001/notificationsHub"
    : "https://tokenapi.likestoryeg.com/notificationsHub";
}
